import React, { useEffect, useState } from 'react';
import NameRoles from './assets/NameRoles';

const AName = ({ name }) => {
  const [error, setError] = useState([]);

  const TestName = (name) => {
    let errors = [];
    for (const pattern of NameRoles) {
      if (pattern.test(name)) {
        errors.push(pattern);
      }
    }
    setError(errors);
  };

  useEffect(() => {
    TestName(name);
  }, [name]);

  const renderErrors = () => {
    return error.map((pattern, index) => (
      <div key={index}>{pattern.toString()}</div>
    ));
  };

  return (
    <td className={error.length > 0 ? 'text-danger' : ''} title={renderErrors()}>
      {name}
      {error.map((pattern, index) => (
        <div key={index}>{pattern.toString()}</div>
      ))}
    </td>
  );
};

export default AName;